import styled from 'styled-components';

import Typography from '@klv/atoms/typography';

export const CalculatorWrapper = styled.div`
  padding-bottom: 32px;
`;

export const Divider = styled.div`
  height: 0.1rem;
  width: 100%;
  margin: 1.2rem 0;

  ${({ theme }) => `
    background-color: ${theme.pricing.cardBorder};
  `}
`;

export const ToggleWrapper = styled.div`
  margin: 3.2rem 0;
`;

export const Text = styled(Typography)`
  flex: 1 0 50%;
  align-items: center;
  column-gap: 0.4rem;
  display: flex;
  font-size: 1.6rem;
  line-height: 1.5;
  text-align: left;
`;

export const Credits = styled(Typography)`
`;

export const MobileText = styled(Typography)`
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: flex-start;

`;
